/**
 * The event and action types the rule editor offers, as one load that the rules list, the
 * editor and the estimate share.
 *
 * The schema changes only with a deployment.
 */

import { snapshotAtoms } from '../snapshotAtoms';
import { api } from '@/api';
import type { RulesSchemaSnapshot } from '@/types/agents';

const PENDING: RulesSchemaSnapshot = {
    schema: { eventTypes: [], actionTypes: [] },
    isLoading: true,
    error: null,
};

const rulesSchema = snapshotAtoms<RulesSchemaSnapshot>(
    PENDING,
    async (): Promise<RulesSchemaSnapshot> => (
        { schema: await api.getRulesSchema(), isLoading: false, error: null }
    ),
);

export const rulesSchemaAtom = rulesSchema.value;
